import useSubCatalogueGroupedData from "hook/useSubCatalogueGroupedData";
import ProductSwiper from "components/commonComponent/productSwiper";
import { assetUrl } from "utils/api";

const SubCatalougeGroupByCatalouge = () => {
  const { subGroupedData, loading } = useSubCatalogueGroupedData();
  return (
    <div className="">
      {subGroupedData.map((catalogue) => {
        if (!catalogue.subcatalogues?.length) return null;
        const allItems = catalogue.items || [];
        if (!allItems.length) return null;
        return (
          <div key={catalogue.catalogue_id} className="">
            {allItems.length > 0 && (
              <ProductSwiper
                data={allItems}
                loading={loading}
                link={`/category/${catalogue.catalogue_id}`}
                title={catalogue.title}
                icon={assetUrl(catalogue.banner_image_path)}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SubCatalougeGroupByCatalouge;
